module.exports = __webpack_public_path__ + "images/website.jpg";


//////////////////
// WEBPACK FOOTER
// ./vively/images/social-media-icons/website.jpg
// module id = 877
// module chunks = 3